import { useMediaProps } from "@zapier/responsive-utils";

/**
 * These sizes are specific to the outermost pricing page layout.
 * Most components should use `useSize` instead.
 */
export const usePricingPageSize = () =>
  useMediaProps({
    all: {
      size: "small",
    },
    ["(min-width: 784px) and (max-width: 1279px)"]: {
      size: "medium",
    },
    ["(min-width: 1280px)"]: {
      size: "large",
    },
  }).size;
